import React from 'react';
import { ShieldCheck } from 'lucide-react';

const eur = (v) => `${Number(v || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
const dateFr = (d) => String(d || '').slice(0, 10).split('-').reverse().join('/');

export const ConfirmerPaiementsBlock = ({ paiements, montantGlobal, resteServeur, onSaisirNouveau }) => {
  const paye = paiements.reduce((t, p) => t + Number(p.montant || 0), 0);
  const reste = resteServeur != null ? Number(resteServeur) : Math.max(montantGlobal - paye, 0);
  return (
    <div className="rounded-xl border border-emerald-300 bg-emerald-50 p-4 space-y-3" data-testid="confirmer-paiements-block">
      <p className="flex items-center gap-2 font-semibold text-emerald-900">
        <ShieldCheck className="h-4 w-4" /> Paiements déjà enregistrés ({paiements.length})
      </p>
      <ul className="divide-y divide-emerald-200 text-sm">
        {paiements.map((p, i) => (
          <li key={p.id || i} className="flex justify-between py-1.5" data-testid={`paiement-enregistre-${i}`}>
            <span className="text-slate-700">{dateFr(p.date_paiement)} · {p.mode_paiement || 'virement'}{p.reference ? ` · ${p.reference}` : ''}</span>
            <span className="font-mono font-semibold text-emerald-700">{eur(p.montant)}</span>
          </li>
        ))}
      </ul>
      <div className="grid grid-cols-2 gap-3 text-sm">
        <div className="rounded-lg bg-white p-2"><p className="text-slate-500">Déjà réglé</p>
          <p className="font-bold text-emerald-700" data-testid="confirmer-total-paye">{eur(paye)}</p></div>
        <div className="rounded-lg bg-white p-2"><p className="text-slate-500">Reste dû</p>
          <p className="font-bold text-red-600" data-testid="confirmer-reste-du">{eur(reste)}</p></div>
      </div>
      <p className="text-xs text-emerald-800">
        La confirmation valide le dossier sans nouvelle saisie : l&apos;attestation et les CP/CG sont générées signées avec QR code de vérification
        et publiées dans la GED et l&apos;espace membre. Le reste dû reste à encaisser.
      </p>
      <button type="button" onClick={onSaisirNouveau} className="text-xs font-medium text-blue-700 underline" data-testid="saisir-nouveau-virement">
        Enregistrer plutôt un nouveau virement
      </button>
    </div>
  );
};
